<template>
    <div class="question mb-4" v-if="question">
        <div v-if="question.text || question.info" class="mb-3">
            <div class="question__title" v-if="question.text">{{question.text}}</div>
            <div class="question__desc caption" v-if="question.info">{{question.info}}</div>
        </div>

        <div>
            <question-radio
                    has-index :index-offset="0"
                    v-if="question.type === 'radio' && question.answers.length"
                    :horizontal="!!question.is_horizontal"
                    :items="question.answers"
                    :error="error"
                    @input="$emit('input', $event)"
                    :value="value"
            />

            <question-checkbox
                    has-index :index-offset="0"
                    v-if="question.type === 'checkbox' && question.answers.length"
                    :items="question.answers"
                    :error="error"
                    :value="value"
                    @input="$emit('input', $event)"
            />

            <question-input
                    v-if="question.type === 'input'"
                    :error="error"
                    :value="value"
                    @input="$emit('input', $event)"
            />
        </div>
    </div>
</template>


<script>
    import {mapGetters} from 'vuex'
    import QuestionRadio from '@/components/question/radio'
    import QuestionCheckbox from '@/components/question/checkbox'
    import QuestionInput from '@/components/question/input'

    export default {
        components: {
            QuestionRadio,
            QuestionCheckbox,
            QuestionInput
        },
        props: {
            id: [String, Number],
            error: Boolean,
            value: [String, Array, Number, Boolean]
        },
        computed: {
            ...mapGetters('questions', ['questions']),
            question () {
                let index = this.questions.findIndex(item => item.id === this.id)
                return this.questions[index]
            }
        },
        data () {
            return {}
        }
    }
</script>

<style lang="stylus" scoped>
    .question {
        &__title {}
        &__desc {
            color #777777
        }
    }
</style>
